export default __webpack_public_path__ + "static/media/jolt-65-4.4f5b6936.jpg";